import React, { PureComponent } from 'react';
import { compose, withProps } from 'recompose';
import { withUrlContext } from 'hoc/url';
import { withEventDetails } from 'graphql/audioCalls';
import { get } from 'utils';
import { EventDetailsUI } from './ui';

export class EventDetails extends PureComponent {
    static displayName = 'EventDetailsContainer';

    render() {
        const { ...rest } = this.props;
        // PUT OTHER PROPS AFTER {...rest}
        return <EventDetailsUI {...rest} />;
    }
}

export const EventDetailsContainer = compose(
    withUrlContext(['audioCallId']),
    withEventDetails({ fetchPolicy: 'cache-only' }),
    withProps(({ audioCall }) => ({
        ...audioCall,
        conference: get(audioCall, 'eventGroups[0]')
    }))
)(EventDetails);
